<template>
  <div>
    <!-- Кнопка открытия модального окна для создания экспертизы -->
    <v-btn class="btn-link" :aria-label="$t('Добавить экспертизу')" @click.native.stop="docsModal = true">
      <label :class="{ invalid: invalid }">{{ $t('Добавить экспертизу') }}</label>
    </v-btn>
    <v-dialog v-model="docsModal" max-width="600">
      <v-card class="modal">
        <div class="modal-head">
          {{ $t('Экспертиза') }}
          <v-btn color="modal-close" :aria-label="$t('Закрыть')" @click.native="docsModal = false">
            <span class="pro-icon-close1" aria-hidden="true"></span>
          </v-btn>
        </div>
        <div class="modal-body">
          <!-- Глобальные поля экспертизы -->
          <v-row>
            <v-col cols="12" sm="12" :class="{ invalid: $v.examination.name.$error }">
              <v-text-field :outlined="true" v-model="examination.name" :label="$t('Наименование экспертизы')"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12">
              <v-select
                v-model="examination.categories"
                label="Категория экспертизы"
                :items="examinationCategories"
                item-text="transName"
                item-value="id"
                multiple
                persistent-hint
                outlined
              />
            </v-col>
            <v-col cols="12" sm="12">
              <v-textarea rows="3" :outlined="true"  v-model="examination.comment" :label="$t('Комментарий')"></v-textarea>
            </v-col>
          </v-row>
          <!-- Блок для загрузки документов -->
          <div>
            <div v-for="(doc, index) in documentList" :key="index">
              <v-row>
                <v-col cols="6" sm="6" class="col-file-input" :class="{ invalid: $v.documentList && $v.documentList[index] && $v.documentList[index].file.$error }">
                  <v-file-input
                    :outlined="true"
                    v-model="doc.file"
                    :label="$t('Загрузить документ')"
                  />
                </v-col>
                <v-col cols="6" sm="6" :class="{ invalid: $v.documentList && $v.documentList[index] && $v.documentList[index].name.$error }">
                  <v-text-field
                    :outlined="true"
                    v-model="doc.name"
                    :label="$t('Наименование документа')">
                  </v-text-field>
                </v-col>
                <v-col cols="6" sm="6">
                  <v-btn color="secondary" @click="removeDocument(index)">
                    {{$t('Удалить файл')}}
                  </v-btn>
                </v-col>
              </v-row>
            </div>
            <v-btn color="primary"  class="mt-2" @click="addDocument">
              {{$t('Добавить документ')}}
            </v-btn>
          </div>
          <!-- Кнопка сохранения экспертизы -->
          <v-row>
            <v-col class="mt-2" cols="12" sm="12">
              <v-btn color="primary" dark @click="submitExamination">
                {{$t('Сохранить')}}
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import GET from '@/store/modules/getNpaData'

export default {
  props: {
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    examination: {
      name: '',
      comment: '',
      categories: []
    },
    documentList: [
      { file: null, name: '' }
    ],
    docsModal: false,
    examinationCategories: [],
  }),
  validations: {
    examination: {
      name: { required }
    },
    documentList: {
      $each: {
        name: { required },
        file: { required }
      }
    }
  },
  mounted() {
    GET.getNpaData()
      .then((response) => {
        this.examinationCategories = response.data.refExaminationCategories
      })
      .catch((error) => {})
  },
  methods: {
    addDocument() {
      this.documentList.push({ file: null, name: '' });
    },
    removeDocument(index) {
      console.log(index)
      this.documentList.splice(index, 1);
    },
    submitExamination() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return false
      }
      const payload = {
        npa_examination_type: {
          name: this.examination.name,
          comment: this.examination.comment,
          documents: this.documentList,
          categories: this.examination.categories
        }
      };
      this.$emit('setDataExaminations', payload);
      this.resetExamination();
      this.docsModal = false;
    },
    resetExamination() {
      this.examination = { name: '', comment: '', categories: [] };
      this.documentList = [];
    }
  }
}
</script>

<style lang="scss">
.file-item {
  textarea {
    height: 100px;
    resize: none;
    border: 1px solid rgba(0, 0, 0, 0.5);
  }
}
</style>
